module.exports = __webpack_public_path__ + "a9cfcac7b9385c5dda152180b0187d6d.jpg";